import type * as lazyIndex from './lazyIndex';
import { LazyImport, LazyModule } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "OwaGroupUtils" */ './lazyIndex'),
    { name: 'OwaGroupUtils' }
);

// Delay loaded imports
export const lazyGetGroupDisplayName: LazyImport<
    typeof lazyIndex.getGroupDisplayName,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.getGroupDisplayName);
export const lazyGetGroupDisplayNameFromTableView: LazyImport<
    typeof lazyIndex.getGroupDisplayNameFromTableView,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.getGroupDisplayNameFromTableView);
export const lazyIsPrivateUnjoinedGroup: LazyImport<
    typeof lazyIndex.isPrivateUnjoinedGroup,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.isPrivateUnjoinedGroup);
export const lazyIsJoinedGroup: LazyImport<typeof lazyIndex.isJoinedGroup, typeof lazyModule> =
    new LazyImport(lazyModule, m => m.isJoinedGroup);
export const lazyIsGroupOwner: LazyImport<typeof lazyIndex.isGroupOwner, typeof lazyModule> =
    new LazyImport(lazyModule, m => m.isGroupOwner);
export const lazyGetGroupUrl: LazyImport<typeof lazyIndex.getGroupUrl, typeof lazyModule> =
    new LazyImport(lazyModule, m => m.getGroupUrl);

export { getSelectedGroupId } from './utils/getGroupId';
export { default as isGroupSelected } from './utils/isGroupSelected';
export { default as isGroupTableQuery, getGroupIdFromTableQuery } from './utils/isGroupTableQuery';
export { default as getGroupMailboxInfoFromTableQuery } from './utils/getGroupMailboxInfoFromTableQuery';
export { getGroupsPanelMailboxInfo } from './utils/getGroupsPanelMailboxInfo';
export { default as isGroupTableSelected } from './utils/isGroupTableSelected';
export { default as isMessageActionFromGroup } from './utils/isMessageActionFromGroup';
